import React, { useEffect, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import Api from '../../../../_helpers/Api'

//components
import Pagination from '../../../app/Pagination'
import Table from './partials/Table'
import Filter from './partials/Filter'

//imags
import loader from '../../../../assets/images/app/loader.svg'
import notFoundIcon from '../../../../assets/images/pages/icons/not-found.png'

//modals
import CreateEdit from './modals/CreateEdit'

function Index() {
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)

    const [machines, setMachines] = useState({
        data: [],
        pages: 1,
        page: searchParams.get('page') || 1,
        loading: true,
        refresh: null,
        types: [],
        filter: {
            name: ''
        }
    })

    //refs
    const createEditRef = useRef(null)
    //end refs

    useEffect(() => {
        startLoading()
        Api.get(`machines/types/get-page?page=${machines.page}&name=${machines.filter.name}`)
            .then(res => {
                setMachines(machines => ({
                    ...machines,
                    data: res.data.items,
                    pages: res.data.page,
                }))
            })
            .finally(() => stopLoading())
    }, [machines.refresh, machines.page, machines.filter])

    const startLoading = () => {
        setMachines(machines => ({
            ...machines,
            loading: true,
        }))
    }
    const stopLoading = () => {
        setMachines(machines => ({
            ...machines,
            loading: false,
        }))
    }

    //refresh
    const handleRefreshData = () => {
        setMachines(machines => ({
            ...machines,
            refresh: new Date()
        }))
    }

    const handlePage = page => {
        setMachines(machines => ({
            ...machines,
            page: page.selected + 1
        }))
    }

    const handleFilter = (name, id) => {
        setMachines(machines => ({
            ...machines,
            filter: {
                ...machines.filter,
                [name]: id
            }
        }))
    }

    const handleAddMachine = () => createEditRef.current.open()

    const handleEditMachine = id => createEditRef.current.open(id)

    return (
        <div className="wrapper task">
            <CreateEdit
                ref={createEditRef}
                handleRefreshData={handleRefreshData}
            />
            <div className="top row">
                <h1></h1>
                <button className="btn-add" onClick={handleAddMachine}>
                    Вид машина
                </button>
            </div>
            <div className="row">
                <Filter
                    handleFilter={handleFilter}
                />
            </div>
            <hr />
            {machines.loading ?
                <img src={loader} alt="loading" />
                :
                machines.data.length == 0 ?
                    <div className="no-results">
                        <img src={notFoundIcon} alt="Няма резултати" />
                        Не бяха намерени резултати.
                    </div>
                    :
                    <div className="row">
                        <Table
                            machines={machines.data}
                            handleEdit={handleEditMachine}
                        />
                    </div>}

            {!machines.loading && <div className="row">
                <Pagination
                    page={machines.page}
                    pages={machines.pages}
                    handlePage={handlePage}
                />
            </div>
            }
        </div>
    )
}

export default Index